import { FormikProps } from "formik";
import _ from "lodash";
import { useTranslation } from "react-i18next";

interface CustomErrorProps<T, Nested> {
    form?: FormikProps<T>;
    name?: keyof T;
    nestedKey?: keyof Nested;
    errorKey?: string;
    className?: string;
}

function CustomError<T, Nested>(props: CustomErrorProps<T, Nested>) {
    const getFormikErrorKey = () => {
        if (!props.form) return "";
        if (!props.name) return Object.values(props.form.errors).find((value) => value) as string;
        const key = props.nestedKey ? `${props.name as string}.${props.nestedKey as string}` : props.name;
        return _.get(props.form.touched, props.name) ? _.get(props.form.errors, key) : "";
    };
    const error = getFormikErrorKey();
    const { t } = useTranslation();
    return (
        <div className={error || props.errorKey ? `error ${props.className}` : "hidden"}>
            {error || t(props.errorKey)}
        </div>
    );
}

export default CustomError;
